import _ from 'lodash';
import { serviceTypeList, serviceType9AList, serviceType9BList } from '@/assets/commonData/options';

function isEmpty(value) {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim() === '';
    return false;
}

function isNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
}

export default {
    // 委外個人姓名,
    outsourceNam: {
        label: '委外個人姓名',
        type: 'text',
        width: 120,
        align: 'left',
        fixed: true,
        showOverflowTooltip: false,
        validate(value, row, { existOutsource }) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '無資料' };
            }
            if (existOutsource) {
                const ERROR_MSG = [];

                if (isEmpty(existOutsource.abd)) ERROR_MSG.push('國籍');
                if (isEmpty(existOutsource.bsN_TYP)) ERROR_MSG.push('證件類型');
                if (existOutsource.abd === 0 ? isEmpty(existOutsource.permanentAddrCty) : isEmpty(existOutsource.permanentAddrAra)) ERROR_MSG.push('戶籍地區');
                if (isEmpty(existOutsource.permanentAddr)) ERROR_MSG.push('戶籍地址');
                if (existOutsource.abd === 0 ? isEmpty(existOutsource.cty) : isEmpty(existOutsource.ara)) ERROR_MSG.push('聯絡地區');
                if (isEmpty(existOutsource.adr)) ERROR_MSG.push('聯絡地址');

                const BNK = _.find(existOutsource.vendorBanks, ['bnK_ACC', row.bnkAcc]);
                if (
                    BNK
                    && (BNK.accountType === 1
                        ? isEmpty(BNK.bnK_BOO) || isEmpty(BNK.bnK_TPC) || isEmpty(BNK.bnK_ACC)
                        : isEmpty(BNK.abroadBankName) || isEmpty(BNK.swiftCode) || isEmpty(BNK.bnK_TPC) || isEmpty(BNK.bnK_ACC))
                ) ERROR_MSG.push('帳戶資料');

                if (ERROR_MSG.length > 0) return { status: 'ERROR', msg: `委外資訊【${ERROR_MSG.join('、')}】不完整` };

                if (existOutsource.fnam !== value) return { status: 'WARNING', msg: '與現有資料不同' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 證件號碼
    bsn: {
        label: '證件號碼',
        type: 'text',
        width: 120,
        align: 'left',
        showOverflowTooltip: false,
        validate(value, row, { existOutsource }) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            if (!existOutsource) {
                return { status: 'ERROR', msg: '查無此委外個人' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 所得類別
    incomeTyp: {
        label: '所得類別',
        type: 'text',
        width: 80,
        align: 'left',
        showOverflowTooltip: false,
        validate(value) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            if (!serviceTypeList.find((x) => x.type === value)) {
                return { status: 'ERROR', msg: '無此類別' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 業別代號
    serviceTyp: {
        label: '業別代號',
        type: 'text',
        width: 150,
        align: 'left',
        showOverflowTooltip: true,
        validate(value, row) {
            if (row.incomeTyp === '9A') {
                if (isEmpty(value)) {
                    return { status: 'ERROR', msg: '不可無資料' };
                }
                const num = value.substring(3, 5);
                if (!serviceType9AList.find((x) => x.key.toString() === num)) {
                    return { status: 'ERROR', msg: '無此類別(9A)' };
                }
            } else if (row.incomeTyp === '9B') {
                if (isEmpty(value)) {
                    return { status: 'ERROR', msg: '不可無資料' };
                }
                const num = value.substring(3, 5);
                if (!serviceType9BList.find((x) => x.key.toString() === num)) {
                    return { status: 'ERROR', msg: '無此類別(9B)' };
                }
            } else if (!isEmpty(value)) {
                return { status: 'WARNING', msg: '多餘的資訊，將會在匯入時捨棄' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 其他業務類別說明
    otherServiceType: {
        label: '其他業務類別說明',
        type: 'text',
        width: 120,
        align: 'left',
        showOverflowTooltip: true,
        validate(value, row) {
            if (row.incomeTyp === '92' && isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            if (row.incomeTyp !== '92' && !isEmpty(value)) {
                return { status: 'WARNING', msg: '多餘的資訊，將會在匯入時捨棄' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 收款帳號
    bnkAcc: {
        label: '收款帳號',
        type: 'text',
        width: 150,
        align: 'left',
        showOverflowTooltip: false,
        validate(value, row, { existOutsource }) {
            if (row.plannedPayWay === '銀行轉帳') {
                if (isEmpty(value)) {
                    return { status: 'ERROR', msg: '銀行轉帳不可無帳號' };
                }
                if (existOutsource && !existOutsource.vendorBanks.find((x) => x.bnK_ACC === value)) {
                    return { status: 'ERROR', msg: '該委外個人無此帳號' };
                }
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 專案代碼
    poo: {
        label: '專案代碼',
        type: 'text',
        width: 120,
        align: 'left',
        showOverflowTooltip: false,
        validate(value, row, { existProject }) {
            if (!isEmpty(value) && !existProject) {
                return { status: 'ERROR', msg: '查無此專案' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 勞務摘要
    nam: {
        label: '勞務摘要',
        type: 'text',
        width: 300,
        align: 'left',
        showOverflowTooltip: true,
        validate(value) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            if (value.length > 200) {
                return { status: 'ERROR', msg: '超過 200 字' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 勞務內容
    content: {
        label: '勞務內容',
        type: 'text',
        width: 300,
        align: 'left',
        showOverflowTooltip: true,
        validate(value) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            if (value.length > 1000) {
                return { status: 'ERROR', msg: '超過 1000 字' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 應付總額
    amt: {
        label: '應付總額',
        type: 'money',
        width: 120,
        align: 'right',
        showOverflowTooltip: false,
        validate(value) {
            if (!isNumber(value)) {
                return { status: 'ERROR', msg: '必須為數字' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 幣別
    cny: {
        label: '幣別',
        type: 'text',
        width: 80,
        align: 'left',
        showOverflowTooltip: false,
        validate(value) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            // !!! 檢查幣別
            return { status: 'OK', msg: '' };
        },
    },

    // 約定匯率
    cnyRat: {
        label: '約定匯率',
        type: 'number',
        width: 90,
        align: 'right',
        showOverflowTooltip: false,
        validate(value, row) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            if (row.cny === 'TWD' && value !== 1) {
                return { status: 'WARNING', msg: '台幣匯率將自動設為1' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 約當台幣
    amtTwd: {
        label: '約當台幣',
        type: 'money',
        width: 120,
        align: 'right',
        showOverflowTooltip: false,
        validate(value) {
            if (!isNumber(value)) {
                return { status: 'ERROR', msg: '必須為數字' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 預計支領方式
    plannedPayWay: {
        label: '預計支領方式',
        type: 'text',
        width: 100,
        align: 'left',
        showOverflowTooltip: false,
        validate(value) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            if (value !== '現金' && value !== '銀行轉帳') {
                return { status: 'ERROR', msg: '格式錯誤' };
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 預計支付日
    plannedPayDat: {
        label: '預計支付日',
        type: 'date',
        width: 100,
        align: 'left',
        showOverflowTooltip: false,
        validate(value) {
            if (isEmpty(value)) {
                return { status: 'ERROR', msg: '不可無資料' };
            }
            // !!! 驗證日期格式
            return { status: 'OK', msg: '' };
        },
    },

    // 代扣所得%
    taxRatio: {
        label: '代扣所得%',
        type: 'number',
        width: 90,
        align: 'right',
        showOverflowTooltip: false,
        validate(value) {
            if (value) {
                if (!isNumber(value)) {
                    return { status: 'ERROR', msg: '必須為數字' };
                }
                if (value < 0) {
                    return { status: 'ERROR', msg: '不可小於0' };
                }
                if (value > 100) {
                    return { status: 'ERROR', msg: '不可大於100' };
                }
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 代扣所得稅金額
    taxAmt: {
        label: '代扣所得稅金額',
        type: 'money',
        width: 120,
        align: 'right',
        showOverflowTooltip: false,
        validate(value) {
            if (value) {
                if (!isNumber(value)) {
                    return { status: 'ERROR', msg: '必須為數字' };
                }
                if (value < 0) {
                    return { status: 'ERROR', msg: '不可小於0' };
                }
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 代扣二代健保%
    gen2Ratio: {
        label: '代扣二代健保%',
        type: 'number',
        width: 115,
        align: 'right',
        showOverflowTooltip: false,
        validate(value) {
            if (value) {
                if (!isNumber(value)) {
                    return { status: 'ERROR', msg: '必須為數字' };
                }
                if (value < 0) {
                    return { status: 'ERROR', msg: '不可小於0' };
                }
                if (value > 100) {
                    return { status: 'ERROR', msg: '不可大於100' };
                }
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 代扣二代健保金額
    gen2Amt: {
        label: '代扣二代健保金額',
        type: 'money',
        width: 120,
        align: 'right',
        showOverflowTooltip: false,
        validate(value) {
            if (value) {
                if (!isNumber(value)) {
                    return { status: 'ERROR', msg: '必須為數字' };
                }
                if (value < 0) {
                    return { status: 'ERROR', msg: '不可小於0' };
                }
            }
            return { status: 'OK', msg: '' };
        },
    },

    // 實付金額
    realPayAmt: {
        label: '實付金額',
        type: 'money',
        width: 120,
        align: 'right',
        showOverflowTooltip: false,
        validate(value) {
            if (value) {
                if (!isNumber(value)) {
                    return { status: 'ERROR', msg: '必須為數字' };
                }
                if (value < 0) {
                    return { status: 'ERROR', msg: '不可小於0' };
                }
            }
            return { status: 'OK', msg: '' };
        },
    },
};
